import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "no-print mb-20" }
const _hoisted_2 = {
  id: "print-area",
  class: "print-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handlePrint
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("打印", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_dropdown, {
        onCommand: _ctx.handleExport,
        class: "ml-10"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "pdf" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("导出 PDF", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, { command: "xlsx" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("导出 Excel", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "success" }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createTextVNode(" 导出", -1)),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onCommand"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.printDetail)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.registerComponent), {
            key: 0,
            detail: _ctx.printDetail,
            id: "print",
            ref: "printComponent"
          }, null, 8, ["detail"]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}